import React from 'react';

import RoundedBox from 'app/shared/componentsRestyled/common/RoundedBox';
import { AutocompleteCDS } from 'app/shared/componentsRestyled/coreDesignSystem/form';
import PropTypes from 'prop-types';

import { CompanyAuthorizedSignerMode } from 'constants/formBuilder';

import { formsTestIds } from '../../../../forms.testIds';
import { AUTHORIZED_SIGNER_MODE_OPTIONS } from '../../Signature.utils';

const EMPTY_OPTIONS = [];

const CompanyAuthorizedSignerConfig = ({ form, validationErrors, onAutocompleteChange }) => (
  <RoundedBox className="flex flex-col gap-12 min-w-[358px]">
    <AutocompleteCDS
      autoHighlight
      required
      dataTestId={formsTestIds.COMPANY_AUTHORIZED_SIGNER_MODE_SELECT}
      label="Mode"
      name="authorizedSignerMode"
      options={AUTHORIZED_SIGNER_MODE_OPTIONS}
      value={form.authorizedSignerMode}
      onChange={onAutocompleteChange}
    />
    {form.authorizedSignerMode?.value === CompanyAuthorizedSignerMode.SINGLE && (
      <AutocompleteCDS
        autoHighlight
        required
        dataTestId={formsTestIds.COMPANY_AUTHORIZED_SIGNER_DESIGNATED_SIGNER_SELECT}
        error={!!validationErrors.authorizedSignerUserId}
        helperText={
          validationErrors.authorizedSignerUserId ||
          'Sub-company authorized signer user (stub — endpoint pending)'
        }
        label="Designated signer"
        name="authorizedSignerUserId"
        options={EMPTY_OPTIONS}
        value={form.authorizedSignerUserId}
        onChange={onAutocompleteChange}
      />
    )}
  </RoundedBox>
);

CompanyAuthorizedSignerConfig.propTypes = {
  form: PropTypes.shape({
    authorizedSignerMode: PropTypes.object,
    authorizedSignerUserId: PropTypes.string,
  }).isRequired,
  validationErrors: PropTypes.object.isRequired,
  onAutocompleteChange: PropTypes.func.isRequired,
};

export default CompanyAuthorizedSignerConfig;
